import { Check, X } from 'lucide-react';
import { comparisonData, companyInfo } from '../data/mock';

export const ComparisonSection = () => {
  return (
    <section 
      id="comparison" 
      className="section-dark"
      style={{ background: 'var(--bg-wood)' }}
    >
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span 
            className="inline-block px-4 py-2 rounded-full mb-4 font-display text-sm uppercase tracking-widest"
            style={{ 
              background: 'rgba(212, 168, 75, 0.15)',
              border: '1px solid var(--border-gold)',
              color: 'var(--gold-primary)'
            }}
          >
            Laser vs Traditional
          </span>
          <h2 className="heading-1 text-gold mb-4">
            See the Difference
          </h2>
          <p 
            className="body-large max-w-2xl mx-auto"
            style={{ color: 'var(--text-muted)' }}
          >
            Why keep paying for treatments that don't work when{' '}
            <span style={{ color: 'var(--gold-primary)' }}>₹{companyInfo.startingPrice}</span> solves it in one visit?
          </p>
        </div>

        {/* Comparison Table - Desktop */}
        <div className="hidden md:block overflow-hidden rounded-xl">
          <table className="comparison-dark">
            <thead>
              <tr>
                <th style={{ width: '30%' }}>Aspect</th>
                <th style={{ width: '35%' }}>
                  <div className="flex items-center gap-2">
                    <Check size={18} />
                    Laser Treatment
                  </div>
                </th>
                <th 
                  style={{ 
                    width: '35%',
                    background: 'var(--bg-wood-light)',
                    color: 'var(--text-muted)'
                  }}
                >
                  <div className="flex items-center gap-2">
                    <X size={18} />
                    Traditional Methods
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, index) => (
                <tr key={index}>
                  <td 
                    className="font-medium"
                    style={{ color: 'var(--text-light)' }}
                  >
                    {row.aspect}
                  </td>
                  <td>
                    <div className="flex items-start gap-2">
                      <Check 
                        size={16} 
                        className="mt-0.5 flex-shrink-0" 
                        style={{ color: 'var(--green-accent)' }} 
                      />
                      <span style={{ color: 'var(--gold-primary)' }}>
                        {row.laser}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div className="flex items-start gap-2">
                      <X 
                        size={16} 
                        className="mt-0.5 flex-shrink-0" 
                        style={{ color: 'var(--red-accent)' }} 
                      />
                      <span style={{ color: 'var(--text-muted)' }}>
                        {row.traditional}
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Comparison Cards - Mobile */}
        <div className="md:hidden space-y-4">
          {comparisonData.map((row, index) => (
            <div 
              key={index} 
              className="card-wood"
              style={{ padding: '1rem' }}
            >
              <div 
                className="font-medium mb-3"
                style={{ color: 'var(--gold-primary)' }}
              >
                {row.aspect}
              </div>
              <div className="space-y-2">
                <div 
                  className="p-3 rounded-lg flex items-start gap-2"
                  style={{ 
                    background: 'rgba(76, 175, 80, 0.1)',
                    border: '1px solid rgba(76, 175, 80, 0.3)'
                  }}
                >
                  <Check 
                    size={16} 
                    className="mt-0.5 flex-shrink-0" 
                    style={{ color: 'var(--green-accent)' }} 
                  />
                  <span className="body-small" style={{ color: 'var(--text-light)' }}>
                    {row.laser}
                  </span>
                </div>
                <div 
                  className="p-3 rounded-lg flex items-start gap-2"
                  style={{ 
                    background: 'rgba(196, 30, 30, 0.1)',
                    border: '1px solid rgba(196, 30, 30, 0.3)'
                  }}
                >
                  <X 
                    size={16} 
                    className="mt-0.5 flex-shrink-0" 
                    style={{ color: 'var(--red-accent)' }} 
                  />
                  <span className="body-small" style={{ color: 'var(--text-muted)' }}>
                    {row.traditional}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
